module.exports = __webpack_public_path__ + "img/phone-signal-full.e4b36223.svg";